import { render, staticRenderFns } from "./type-select.vue?vue&type=template&id=388818f5&"
import script from "./type-select.vue?vue&type=script&lang=js&"
export * from "./type-select.vue?vue&type=script&lang=js&"
import style0 from "./type-select.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports